import { css } from '@emotion/react';
import { Button, Col, Form, Row, Space, Typography } from 'antd';
import { ProductDetails } from '@/components/forms/product-management/product.form';
import {
  getDetailProduct,
  watchDetailProductById
} from '@/redux/slices/product.slice';
// import { ProductManagementEditForm } from '@/components/forms/product-management/edit.form';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useEffect } from 'react';
import { PageURLs } from '@/utils/navigate';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import IMAGE_DEFAULT from '@/assets/images/image_default.png';

type FoodInformationModalProps = {
  product: any;
  onCancel: () => void;
  setActiveTabProps: React.Dispatch<React.SetStateAction<string>>;
};

export const ProductInformationModal = ({
  product,
  onCancel
}: FoodInformationModalProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const infoProduct = useAppSelector(watchDetailProductById);
  const { push } = useQuery();

  useEffect(() => {
    dispatch(getDetailProduct(product.id));
  }, [dispatch, product]);

  useEffect(() => {
    if (infoProduct) {
      form.setFieldsValue({
        thumbnail: infoProduct.thumbnail,
        logo: infoProduct.logo,
        shortDesc: infoProduct.shortDesc,
        tag: infoProduct.tag,
        idFood: infoProduct.idFood,
        nameFood: infoProduct.foodName
      });
    }
  }, [form, infoProduct]);

  const onEdit = () => {
    if (!infoProduct?.id) return;
    push(
      `${PageURLs.ofProductManagement()}?mode=${PermissionMode.EDIT}&productId=${infoProduct.id}`
    );
    onCancel();
  }
  return (
    <Form form={form} validateTrigger="onSubmit" css={containerStyles}>
      <Typography.Title css={titleStyles} level={5}>
        Thông tin sản phẩm
      </Typography.Title>

      <Row align="middle" justify="space-between" gutter={32} css={css`padding: 0 8rem;`}>
        <Col>
          <Row align="middle" gutter={16}>
            <Col>
              <img
                src={infoProduct?.thumbnail || IMAGE_DEFAULT}
                style={{ width: '100px', aspectRatio: '3/2', objectFit: 'cover' }}
                alt="Product Thumbnail"
              />
            </Col>
            <Col>
              <Typography.Title level={5} css={imageTitleStyles}>
                {infoProduct?.name}
              </Typography.Title>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row align="middle" gutter={16}>
            <Col>
              <img
                src={infoProduct?.logo || IMAGE_DEFAULT}
                style={{ width: '100px', aspectRatio: '3/2', objectFit: 'cover' }}
                alt="Product Logo"
              />
            </Col>
            <Col>
              <Typography.Title level={5} css={imageTitleStyles}>
                Logo Nhãn sản phẩm
              </Typography.Title>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <ProductDetails />
      </Row>

      <Form.Item>
        <Space css={groupButtonStyles}>
          <Button type="default" size="large" onClick={onCancel}>
            Đóng
          </Button>
          <Button type="primary" size="large" onClick={onEdit}>
            Chỉnh sửa
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

const containerStyles = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-height: 90vh;

  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const titleStyles = css`
  margin-bottom: 1.6rem !important;
  line-height: 3.2rem !important;
`;

const imageTitleStyles = css`
  margin: 0 !important;
`;

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-top: 1.6rem;

  button {
    padding: 0.5rem 2rem;
    font-size: 16px;
  }
`;